<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <v-icon icon="spoke" :title="t('component.iconConsumable.title')" />
</template>

<style scoped lang="scss"></style>
